const getDeviceInfo = () => {
  const hasNavigator = typeof navigator !== 'undefined';
  const hasWindow = typeof window !== 'undefined';

  return {
    userAgent: hasNavigator ? navigator.userAgent : 'unknown',
    platform: hasNavigator
      ? navigator.userAgentData?.platform || navigator.platform || 'unknown'
      : 'unknown',
    language: hasNavigator ? navigator.language : 'unknown',
    screenSize: hasWindow
      ? `${window.screen.width}x${window.screen.height}`
      : 'unknown',
    timezone:
      typeof Intl !== 'undefined' && Intl.DateTimeFormat
        ? Intl.DateTimeFormat().resolvedOptions().timeZone
        : 'unknown',
    hardwareConcurrency:
      hasNavigator && 'hardwareConcurrency' in navigator
        ? navigator.hardwareConcurrency
        : 'unknown',
    deviceMemory:
      hasNavigator && 'deviceMemory' in navigator
        ? navigator.deviceMemory
        : 'unknown',
    isTouchDevice: hasWindow
      ? 'ontouchstart' in window ||
        (hasNavigator && navigator.maxTouchPoints > 0)
      : false,
  };
};

export default getDeviceInfo;
